import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * @deprecated The method should not be used. Please use useQueryParamsV2 instead.
 */
const useQueryParams = () => {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export default useQueryParams
